// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__27FTK","choiceBoxes":"toolbarselects_choiceBoxes__33LXs","simpleField":"toolbarselects_simpleField__2Udqb"};